/* ============================================================
   TRADIE — Mixed colours: hide picker arrows when nothing overflows
   Pairs with colour-mixer-picker-arrows.css.

   See the CSS file for the full root cause (missing
   watchOverflow: true on the Swiper instance in pf-custom.js).

   Measures the swatch picker directly: .swiper-wrapper lays out all
   swatch slides in a row via Swiper's transform-based positioning
   (not native scrollLeft), so its natural scrollWidth still reflects
   the full laid-out width of every slide regardless of how Swiper is
   currently transformed/positioned. Comparing that against the
   .swiper container's own clientWidth (the actually-visible width)
   gives an accurate "would anything need to scroll" check that
   doesn't depend on Swiper's internal state at all.

   Both arrows are shown/hidden together here (this only handles the
   "does this row overflow at all" case) — Swiper's own per-edge
   dimming (.swiper-button-disabled, unaffected by this script) still
   separately fades an arrow out once you've scrolled to that edge.
   ============================================================ */

(function () {
  function updatePickerArrows() {
    document.querySelectorAll('.pf-color-mixer .pf-colmix-list').forEach(function (list) {
      const swiperEl = list.querySelector('.swiper');
      const wrapper = list.querySelector('.swiper-wrapper');
      const prevBtn = list.querySelector('.pf-colmix-prev');
      const nextBtn = list.querySelector('.pf-colmix-next');

      if (!swiperEl || !wrapper) return;

      const hasOverflow = wrapper.scrollWidth > swiperEl.clientWidth + 4;

      if (prevBtn) prevBtn.hidden = !hasOverflow;
      if (nextBtn) nextBtn.hidden = !hasOverflow;
    });
  }

  window.addEventListener('resize', updatePickerArrows);
  window.addEventListener('load', updatePickerArrows);
  document.addEventListener('DOMContentLoaded', updatePickerArrows);

  // Re-check whenever the swatch list re-renders (colour add/remove,
  // size selection swapping which colours are in stock, etc.)
  let scheduled = false;
  const observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      updatePickerArrows();
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
